import React, { useState, useEffect } from "react";
import { Box, Typography, Container, Autocomplete, CircularProgress, FormControl, TextField, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { styles } from "../../styles/styles";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

import {
	StyledTextField,
	StyledFormControl,
	FormContainer,
	StyledButton,
	FormGrid,
} from "../../common/FormStyles";
import { InputLabel, MenuItem, Select } from "@mui/material";
import {
	getFamilyStatusList,
	getFamilyTypeList,
	getCitiesList,
	getReligionsList,
	getCastesList,
	updateFamilyDetails,
	getHealthConditionList,
	getProfileDetails, getCountriesList, getStatesList, getDistrictsList,
	getStatesListByCountry,
	getDistrictsListByState,
	getCitiessListByDistrict,
	getRelationsList,
	getDesignationList, getEmployedInList
} from "../../../services/operations/userOperations";
const FAMILY_FIELDS_CONFIG = {
	basicFields: [
		{
			label: "Family Status",
			type: "select",
			name: "familyStatus",
		},
		{
			label: "Family Type",
			type: "select",
			name: "familyType",
		},
		{
			label: "Permanent Address",
			type: "textarea",
			name: "familyPermanentAddress",
		},
		{
			label: "Present Address",
			type: "textarea",
			name: "familyPresentAddress",
		},
		{
			label: "Number of Brothers",
			type: "select",
			name: "numberOfBrothers",
		},
		{
			label: "Number of Sisters",
			type: "select",
			name: "numberOfsisters",
		},
	],
	fatherFields: [
		{
			label: "Father Name",
			type: "text",
			name: "fatherName",
		},
		{
			label: "Father Religion",
			type: "select",
			name: "fatherReligion",
		},
		{
			label: "Father Caste",
			type: "select",
			name: "fatherCaste",
		},
		{
			label: "Father Status",
			type: "select",
			name: "fatherStatus",
		},
		{
			label: "Father Health Condition",
			type: "select",
			name: "fatherHealthCondition",
		},
		{
			label: "Father Working Sector",
			type: "select",
			name: "fatherWorkingSector",
		},
		{
			label: "Father Mobile Number",
			type: "text",
			name: "fatherMobileNumber",
		},
		{
			label: "Father Annual Income",
			type: "number",
			name: "fatherAnualIncome",
		},
		{
			label: "Father Property Details",
			type: "textarea",
			name: "fatherPropertyDetails",
		},
		{
			label: "Father Address",
			type: "textarea",
			name: "fatherAddress",
		},
		{
			label: "Is Father Converted Caste",
			type: "select",
			name: "isFatherConvertedCaste",
		},
		{
			label: "Pension",
			type: "text",
			name: "pension",
		},
	],
	motherFields: [
		{
			label: "Mother Name",
			type: "text",
			name: "motherName",
		},
		{
			label: "Mother Maiden Name",
			type: "text",
			name: "motherMaidenName",
		},
		{
			label: "Mother Religion",
			type: "select",
			name: "motherReligion",
		},
		{
			label: "Mother Caste",
			type: "select",
			name: "motherCaste",
		},
		{
			label: "Mother Status",
			type: "select",
			name: "motherStatus",
		},
		{
			label: "Mother Health Condition",
			type: "select",
			name: "motherHealthCondition",
		},
		{
			label: "Mother Mobile Number",
			type: "text",
			name: "motherMobileNumber",
		},
		{
			label: "Mother Annual Income",
			type: "number",
			name: "motherAnualIncome",
		},
		{
			label: "Mother Property Details",
			type: "textarea",
			name: "motherPropertyDetails",
		},
		{
			label: "Is Mother Converted Caste",
			type: "select",
			name: "isMotherConvertedCaste",
		},
	],
	referenceFields: [
		{
			label: "Reference Name",
			type: "text",
			name: "referenceName",
		},
		{
			label: "Reference Mobile Number",
			type: "text",
			name: "referenceMobileNmuber",
		},
		{
			label: "Relation",
			type: "select",
			name: "relation",
		},
		{
			label: "Reference Address",
			type: "textarea",
			name: "referenceAddress",
		},
	],
};

const FamilyDetailsForm = (props) => {
	const navigate = useNavigate();
	const { type,onSubmitSuccess } = props
	const [familyStatusList, setFamilyStatusList] = useState([]);
	const [selectedFamilyStatus, setSelectedFamilyStatus] = useState(null);
	const [familyTypes, setFamilyTypes] = useState([]);
	const [selectedFamilyType, setSelectedFamilyType] = useState(null);
	const [cities, setCities] = useState([]);
	const [religions, setReligions] = useState([]);
	const [fatherReligion, setFatherReligion] = useState(null);
	const [motherReligion, setMotherReligion] = useState(null);
	const [castes, setCastes] = useState([]);
	const [fatherCaste, setFatherCaste] = useState(null);
	const [motherGotra, setMotherGotra] = useState(null);
	const [motherCaste, setMotherCaste] = useState(null);
	const [relation, setRelation] = useState(null);
	const [countriesList, setCountriesList] = useState([]);
	const [statesList, setStatesList] = useState([]);
	const [districtsList, setDistrictsList] = useState([]);
	const [citiesList, setCitiesList] = useState([]);
	const [country, setCountry] = useState("");
	const [state, setState] = useState("");
	const [district, setDistrict] = useState("");
	const [city, setCity] = useState("");
	const [relationList, setRelationList] = useState([])
	const [professionsList, setProfessionsList] = useState([])
	const [fatherProfession, setFatherProfession] = useState(null)
	const [motherProfession, setMotherProfession] = useState(null)
	const [fatherReligionValue, setFatherReligionValue] = useState(null)
	const [motherReligionValue, setMotherReligionValue] = useState(null)
	const [gotra, setGotra] = useState(null)
	const [employedIn, setEmployedIn] = useState([])
	const [selectedLocation, setSelectedLocation] = useState({
		countryId: "",

		cityId: null,
		// cityName: "",
		// districtName: "",
		// stateName: "",
		// countryName: "",
	});

	const gotras = [
		{ label: "Bharadwaja", value: "bharadwaja" },
		{ label: "Kashyapa", value: "kashyapa" },
		{ label: "Vasistha", value: "vasistha" },
		{ label: "Vishvamitra", value: "vishvamitra" },
		{ label: "Gautama", value: "gautama" },
		{ label: "Atri", value: "atri" },
		{ label: "Jamadagni", value: "jamadagni" },
		{ label: "Agastya", value: "agastya" },
		{ label: "Bhrigu", value: "bhrigu" },
		{ label: "Parashara", value: "parashara" },
		{ label: "Sankriti", value: "sankriti" },
		{ label: "Shandilya", value: "shandilya" },
		{ label: "Mandavya", value: "mandavya" },
		{ label: "Kaushika", value: "kaushika" },
		{ label: "Harita", value: "harita" },
		{ label: "Mudgala", value: "mudgala" },
		{ label: "Pulastya", value: "pulastya" },
		{ label: "Pulaha", value: "pulaha" },
		{ label: "Kratu", value: "kratu" },
		{ label: "Marichi", value: "marichi" },
		{ label: "Chyavana", value: "chyavana" },
		{ label: "Dhananjaya", value: "dhananjaya" },
		{ label: "Srivatsa", value: "srivatsa" },
		{ label: "Vatsa", value: "vatsa" },
		{ label: "Kapila", value: "kapila" },
		{ label: "Durvasa", value: "durvasa" },
		{ label: "Koundinya", value: "koundinya" },
		{ label: "Lohit", value: "lohit" },
		{ label: "Saunaka", value: "saunaka" },
		{ label: "Gargya", value: "gargya" },
		{ label: "Bharani", value: "bharani" },
		{ label: "Shrungi", value: "shrungi" },
		{ label: "Bhargava", value: "bhargava" },
		{ label: "Upamanyu", value: "upamanyu" },
		{ label: "Kaumara", value: "kaumara" },
		{ label: "Maitraya", value: "maitraya" },
		{ label: "Yaska", value: "yaska" }
	];

	const [alert, setAlert] = useState({
		open: false,
		message: "",
		severity: "success",
	});
	const [formData, setFormData] = useState({
		fatherName: "",
		fatherMobileNumber: "",
		fatherProfession: "",
		fatherWorkingSector: "",
		fatherAnualIncome: "",
		fatherPropertyDetails: "",
		fatherAddress: "",
		fatherHealthCondition: 1,
		fatherStatus: "",
		isFatherConvertedCaste: 0,
		pension: "",
		motherName: "",
		motherMaidenName: "",
		motherMobileNumber: "",
		motherMobileNumberCountryCode: "+91",
		motherProfession: "",
		motherAnualIncome: "",
		motherPropertyDetails: "",
		motherHealthCondition: 1,
		isMotherConvertedCaste: 0,
		motherStatus: "",
		familyPermanentAddress: "",
		familyPresentAddress: "",
		numberOfBrothers: 0,
		numberOfsisters: 0,
		referenceName: "",
		referenceMobileCountryCode: "+91",
		referenceMobileNmuber: "",
		relation: "",
		referenceAddress: "",
		mothenPension: "",
		brothers: [],
		sisters: [],
	});
	let userType = sessionStorage.getItem("userType")
	let token
	if (userType) {
		token = sessionStorage.getItem("token");
	} else {
		token = localStorage.getItem("token");
	}
	const [healthConditionsList, setHealthConditionsList] = useState([]);

	// Add status mappings as constants
	const FATHER_STATUS = {
		employed: 1,
		business: 2,
		retired: 3,
		not_alive: 4,
	};

	const MOTHER_STATUS = {
		housewife: 1,
		employed: 2,
		business: 3,
		retired: 4,
		not_alive: 5,
	};

	useEffect(() => {

		const fetchData = async () => {
			const countriesList = await getCountriesList()
			if (countriesList.status) {
				setCountriesList(countriesList?.data)
			}

			if (token) {
				try {
					// Fetch health conditions first
					const healthResponse = await getHealthConditionList();
					if (healthResponse.status) {
						console.log("Setting health conditions:", healthResponse.data);
						setHealthConditionsList(healthResponse.data);
					}

					// Then fetch other data
					const [
						familyStatusResponse,
						familyTypesResponse,
						citiesResponse,
						religionsResponse,
						castesResponse,
						relationsResponse,
						professionsResponse,
						employedInResponse
					] = await Promise.all([
						getFamilyStatusList(),
						getFamilyTypeList(),
						getCitiesList("", false),
						getReligionsList(),
						getCastesList(),
						getRelationsList(),
						getDesignationList(),
						getEmployedInList()
					]);

					if (familyStatusResponse.status)
						setFamilyStatusList(familyStatusResponse.data);
					if (familyTypesResponse.status)
						setFamilyTypes(familyTypesResponse.data);
					if (citiesResponse.status) setCities(citiesResponse.data);
					if (religionsResponse.status) setReligions(religionsResponse.data);
					if (castesResponse.status) setCastes(castesResponse.data);
					if (relationsResponse.status) setRelationList(relationsResponse.data);
					if (relationsResponse.status) setProfessionsList(professionsResponse.data);
					if (employedInResponse.status) setEmployedIn(employedInResponse.data);
				} catch (error) {
					console.error("Error fetching data:", error);
				}
			}
		};

		fetchData();
	}, [type]);
	const getFullMobileNumber = (mobileNumber, countryCode) => {
		if (!mobileNumber || !countryCode) return "";

		const normalizedCode = countryCode.replace("+", "").trim();
		const normalizedNumber = mobileNumber.replace(/^0+/, ""); // Remove leading zeros

		return normalizedCode + normalizedNumber;
	};
	const [profileData, setProfileData] = useState(null);
	const updateBrother = (index, key, value) => {
		const updated = [...formData.brothers];
		updated[index] = { ...updated[index], [key]: value };
		setFormData({ ...formData, brothers: updated });
	};

	const updateSister = (index, key, value) => {
		const updated = [...formData.sisters];
		updated[index] = { ...updated[index], [key]: value };
		setFormData({ ...formData, sisters: updated });
	};

	const handleBrothersChange = (count) => {
		const arr = Array.from({ length: parseInt(count) }, () => ({}));
		setFormData({ ...formData, numberOfBrothers: count, brothers: arr });
	};

	const handleSistersChange = (count) => {
		const arr = Array.from({ length: parseInt(count) }, () => ({}));
		setFormData({ ...formData, numberOfsisters: count, sisters: arr });
	};
	useEffect(() => {
		const fetchProfile = async () => {
			try {
				const response = await getProfileDetails();
				if (response.status) {
					setProfileData(response.data);
				}
			} catch (error) {
				console.error("Error fetching profile details:", error);
			}
		};

		fetchProfile();
	}, [type]);

	useEffect(() => {
		const fetchAndPopulateData = async () => {
			try {
				const response = await getProfileDetails();
				if (response.status && response.data?.familyDetails) {
					const data = response.data.familyDetails;

					// Basic family details
					setSelectedFamilyStatus(
						familyStatusList.find((fs) => fs.id === data.familyStatus) || null
					);
					setSelectedFamilyType(
						familyTypes.find((ft) => ft.id === data.familyType?.id) || null
					);
					setRelation(relationList.find((rel) => rel.id == data.relation?.id) || null)
					let previousCountry = countriesList.find((country) => country.id == data.country?.id) || null
					setCountry(previousCountry || null)
					if (previousCountry) {
						await handleCountryChange("event", previousCountry)
					}
					let previousState = statesList.find((state) => state.id == data.state?.id) || null
					setState(data.state || null)
					if (previousState) {
						await handleStateChange("event", previousState)
					}
					let previousDistrict = districtsList.find((district) => district.id == data.district?.id) || null
					setDistrict(data.district || null)
					if (previousDistrict) {
						await handleDistrictChange("event", previousDistrict)
					}
					setCity(data.city || null)
					let previousReligion = religions.find((religion) => religion.id == data.fatherReligion?.id)
					setFatherReligionValue(previousReligion || null)
					setMotherReligionValue(religions.find((religion) => religion.id == data.motherReligion?.id) || null)
					setGotra(gotras.find((gotra) => gotra.label == data.fatherGotra) || null)
					setMotherGotra(gotras.find((gotra) => gotra.label == data.motherGotra) || null)
					setFatherCaste(data?.fatherCast || null)
					// setMotherCaste(castes.find((cast) => cast.id == data.motherCaste?.id) || null)
					setMotherCaste(data?.motherCast || null)
					setFatherProfession(data?.fatherProfession ? professionsList.find((profession) => profession.id == data.fatherProfession?.id) : null)
					setMotherProfession(data?.motherProfession ? professionsList.find((profession) => profession.id == data.motherProfession?.id) : null)


					// Father details
					setFormData((prev) => ({
						...prev,
						fatherName: data.fatherName || "",
						// fatherReligion: fatherReligion || null,
						// fatherCaste: data.fatherCaste,
						isFatherConvertedCaste: data.isFatherConvertedCaste || 0,
						fatherStatus: data.fatherStatus?.toString() || "",
						fatherHealthCondition: data.fatherHealthCondition || 1,
						fatherWorkingSector: data.fatherWorkingSector || "",
						fatherMobileNumber: getFullMobileNumber(data.fatherMobileNumber, data.fatherMobileNumberCountryCode) || "",
						fatherAnualIncome: data.fatherAnualIncome?.toString() || "",
						fatherPropertyDetails: data.fatherPropertyDetails || "",
						fatherAddress: data.fatherAddress || "",
						pension: data.pension || "",
						mothenPension: data.mothenPension || "",

						// Mother details
						motherName: data.motherName || "",
						motherMaidenName: data.motherMaidenName || "",
						// motherReligion: data.motherReligion,
						// motherCaste: data.motherCaste,
						isMotherConvertedCaste: data.isMotherConvertedCaste || 0,
						motherHealthCondition: data.motherHealthCondition || 1,
						motherMobileNumber: getFullMobileNumber(data.motherMobileNumber, data.motherMobileNumberCountryCode) || "",
						motherStatus: data.motherStatus?.toString() || "",
						motherAnualIncome: data.motherAnualIncome?.toString() || "",
						motherPropertyDetails: data.motherPropertyDetails || "",

						// Family address and siblings
						familyPermanentAddress: data.familyPermanentAddress || "",
						familyPresentAddress: data.familyPresentAddress || "",
						numberOfBrothers: data.numberOfBrothers?.toString() || "0",
						numberOfsisters: data.numberOfsisters?.toString() || "0",

						// Reference details
						referenceName: data.referenceName || "",
						referenceMobileNmuber: getFullMobileNumber(data.referenceMobileNmuber, data.referenceMobileCountryCode) || "",
						relation: data.relation?.toString() || "",
						referenceAddress: data.referenceAddress || "",
						sisters: data?.sisters.map(({ age, maritalStatus }) => ({ age, maritalStatus })) ?? [],
						brothers: data?.brothers.map(({ age, maritalStatus }) => ({ age, maritalStatus })) ?? [],
					}));
				}
			} catch (error) {
				console.error("Error fetching profile data:", error);
			}
		};
		fetchAndPopulateData();
	}, [familyStatusList, familyTypes, religions, castes, type]);
	const handleCountryChange = async (event, newValue) => {
		if (newValue) {
			const stateResponse = await getStatesListByCountry(newValue.id);
			if (stateResponse.status) {
				setStatesList(stateResponse?.data);
			}
		}

		setCountry(newValue);

		setProfileData(prev => ({
			...prev,
			familyDetails: {
				...prev.familyDetails,
				country: newValue
			}
		}));
	};

	const handleStateChange = async (event, newValue) => {
		if (newValue) {
			const districtResponse = await getDistrictsListByState(newValue.id)
			if (districtResponse.status) {
				setDistrictsList(districtResponse?.data)
			}
		}

		setState(newValue);

	}

	const handleDistrictChange = async (event, newValue) => {
		if (newValue) {
			const citiesResponse = await getCitiessListByDistrict(newValue.id)
			if (citiesResponse.status) {
				setCitiesList(citiesResponse?.data)
			}

		}

		setDistrict(newValue)
	}
	const handleCityChange = async (event, newValue) => {
		setCity(newValue)
	}
	const handleContinue = async () => {
		try {

			const getLocalMobileNumber = (fullNumber, countryCode) => {
				if (!fullNumber || !countryCode) return "";

				// Normalize: Remove "+" and any leading zeros just in case
				const normalizedCode = countryCode.replace("+", "").trim();

				// If number starts with country code, remove it
				if (fullNumber.startsWith(normalizedCode)) {
					return fullNumber.slice(normalizedCode.length);
				}

				return fullNumber; // fallback if code is not at the start
			};
			let newPayload = {
				"familyStatus_id": selectedFamilyStatus?.id || 0,
				"familyType_id": selectedFamilyType?.id || 0,
				"familyPermanentAddress": formData.familyPermanentAddress || "",
				"familyPresentAddress": formData.familyPresentAddress || "",
				"numberOfBrothers": Number(formData.numberOfBrothers) || 0,
				"numberOfsisters": Number(formData.numberOfsisters) || 0,
				"country_id": country ? country.id : 0,
				"state_id": state ? state.id : 0,
				"district_id": district ? district.id : 0,
				"city_id": city ? city.id : 0,
				"fatherName": formData.fatherName || "",
				"fatherReligion_id": fatherReligionValue?.id || 0,
				"fatherCast_id": fatherCaste?.id || 0,
				"fatherGotra": gotra?.label || "",
				"motherGotra": motherGotra?.label || "",
				"isFatherConvertedCaste": formData.isFatherConvertedCaste || 0,
				"fatherStatus": Number(formData.fatherStatus) || 0,
				"fatherHealthCondition_id": formData.fatherHealthCondition?.id || null,
				"fatherWorkingSector_id": formData.fatherWorkingSector ? formData.fatherWorkingSector?.id : null,
				"fatherMobileNumberCountryCode": formData.fatherMobileNumberCountryCode || "+91",
				"fatherMobileNumber": formData.fatherMobileNumber ? await getLocalMobileNumber(formData.fatherMobileNumber, formData.fatherMobileNumberCountryCode || "+91") : "",
				"fatherProfession_id": fatherProfession?.id || 0,
				"fatherAddress": formData.fatherAddress,
				"fatherAnualIncome": Number(formData.fatherAnualIncome) || 0,
				"fatherPropertyDetails": formData.fatherPropertyDetails,
				"pension": formData.pension || "",
				"motherName": formData.motherName,
				"motherMaidenName": formData.motherMaidenName || "",
				"motherReligion_id": motherReligionValue?.id || 0,
				"motherCast_id": motherCaste?.id || 0,
				"isMotherConvertedCaste": formData.isMotherConvertedCaste || 0,
				"motherHealthCondition_id": formData.motherHealthCondition?.id || null,
				"motherMobileNumberCountryCode": formData.motherMobileNumberCountryCode || "+91",
				"motherMobileNumber": formData.motherMobileNumber ? await getLocalMobileNumber(formData.motherMobileNumber, formData.motherMobileNumberCountryCode || "+91") : "",
				"motherProfession_id": motherProfession ? Number(motherProfession?.id) : 0,
				"motherAnualIncome": Number(formData.motherAnualIncome) || 0,
				"motherPropertyDetails": formData.motherPropertyDetails,
				"referenceName": formData.referenceName,
				"referenceMobileCountryCode": formData.referenceMobileCountryCode || "+91",
				"referenceMobileNmuber": formData.referenceMobileNmuber ? await getLocalMobileNumber(formData.referenceMobileNmuber, formData.referenceMobileCountryCode || "+91") : "",
				"relation_id": Number(relation?.id) || 0,
				"referenceAddress": formData.referenceAddress,
				"motherStatus": Number(formData.motherStatus) || 0,
				"mothenPension": formData?.mothenPension || "",
				sisters: formData?.sisters && formData?.sisters.length > 0 ? formData?.sisters : null,
				brothers: formData?.brothers && formData?.brothers.length > 0 ? formData?.brothers : null
			}


			const response = await updateFamilyDetails(newPayload);

			if (!response.status) {
				setAlert({
					open: true,
					message: response.message,
					severity: "error",
				});
				return;
			}

			setAlert({
				open: true,
				message: "Family details updated successfully",
				severity: "success",
			});
			if (type != "edit") {
				setTimeout(() => {
					navigate("/profile/partner-preferences");
				}, 1000);
			}else{
				onSubmitSuccess?.();
			}

		} catch (error) {
			setAlert({
				open: true,
				message: error.message || "Failed to update family details",
				severity: "error",
			});
		}
	};

	return (
		<Container
			maxWidth={false} sx={{ maxWidth: "none" }}
		>
			{type != "edit" && <Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					flexDirection: { xs: "column", md: "row" },
					px: { xs: 0, sm: 25 },
					py: { xs: 2 }
				}}
			>
				<Box sx={{ textAlign: { xs: "center", md: "left" }, mb: { xs: 2, md: 0 } }}>
					<img
						src="/images/Frame 148.png"
						alt="Logo"
						style={{
							maxWidth: "330px",
							width: "100%",
							height: "auto",
						}}
					/>
				</Box>

				<Box
					sx={{
						position: "relative",
						width: 180,
						height: 180,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<CircularProgress
						variant="determinate"
						value={100}
						size={120}
						thickness={3}
						sx={{
							position: "absolute",
							color: "#F0E0D0",
						}}
					/>
					<CircularProgress
						variant="determinate"
						value={profileData?.profileStrength}
						size={120}
						thickness={3}
						sx={{
							position: "absolute",
							color: "#B56E2C",
						}}
					/>
					<Box sx={{ textAlign: "center" }}>
						<Typography sx={{ fontSize: "30px", color: "#B56E2C" }}>{profileData?.profileStrength}%</Typography>
						<Typography sx={{ color: "#B56E2C" }}>completed</Typography>
					</Box>
				</Box>
			</Box>}
			<FormContainer elevation={0} sx={{ ...styles.formCard }}>
				<DecorativeCorner
					sx={{ top: -20, left: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ top: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }}
				/>

				<div className="form-content">
					
				<div style={{display:"flex",justifyContent:"space-between"}}>
					<Typography variant="h6" style={styles.formTitle}>
						Family Details
					</Typography>
					{(type != "edit" && profileData?.profileStrength >= 65) &&  <Button
					variant="outlined"
					color="secondary"
					sx={{ ...styles.skipButton }}
					onClick={() => {
						window.location.href = "/profile/DetaliesDashbord?type=suggested-profiles";
					}}


					>
					Skip
					</Button>}
					</div>
					<FormGrid>
						{/* Family Status and Type */}
						<Autocomplete
							options={familyStatusList}
							getOptionLabel={(option) => option.name}
							value={
								familyStatusList.find(
									(option) => option.id === profileData?.familyDetails?.fatherStatus
								) || selectedFamilyStatus
							}
							onChange={(event, newValue) => {
								setSelectedFamilyStatus(newValue);
							}}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Family Status"
									variant="outlined"
									size="small"
								/>
							)}
						/>
						{/* <Autocomplete
							options={familyStatusList}
							getOptionLabel={(option) => option.name}
							value={
								selectedFamilyStatus ||
								familyStatusList.find(
									(option) => option.id === profileData?.familyDetails?.familyStatus?.id
								) || null
							}
							onChange={(event, newValue) => {
								setSelectedFamilyStatus(newValue);
							}}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Family Status"
									variant="outlined"
									size="small"
								/>
							)}
						/> */}

						<Autocomplete
							options={familyTypes}
							getOptionLabel={(option) => option.name}
							value={selectedFamilyType}
							onChange={(event, newValue) => {
								setSelectedFamilyType(newValue);
							}}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Family Type"
									variant="outlined"
									size="small"
								/>
							)}
						/>

						<StyledTextField
							fullWidth
							label="Permanent Address"
							variant="outlined"
							size="small"
							multiline
							rows={3}
							value={formData.familyPermanentAddress}
							onChange={(e) =>
								setFormData({
									...formData,
									familyPermanentAddress: e.target.value,
								})
							}
						/>

						<StyledTextField
							fullWidth
							label="Present Address"
							variant="outlined"
							size="small"
							multiline
							rows={3}
							value={formData.familyPresentAddress}
							onChange={(e) =>
								setFormData({
									...formData,
									familyPresentAddress: e.target.value,
								})
							}
						/>
						<FormControl fullWidth size="small" sx={{ mb: 2 }}>
							<InputLabel>Brothers</InputLabel>
							<Select
								label="Brothers"
								value={formData.numberOfBrothers}
								onChange={(e) => handleBrothersChange(e.target.value)}
							>
								{[0, 1, 2, 3, 4].map((val) => (
									<MenuItem key={val} value={val}>{val}</MenuItem>
								))}
							</Select>
						</FormControl>
						<FormControl fullWidth size="small" sx={{ mb: 2 }}>
							<InputLabel>Sisters</InputLabel>
							<Select
								label="Sisters"
								value={formData.numberOfsisters}
								onChange={(e) => handleSistersChange(e.target.value)}
							>
								{[0, 1, 2, 3, 4].map((val) => (
									<MenuItem key={val} value={val}>{val}</MenuItem>
								))}
							</Select>
						</FormControl>

						{/* Brother Age and Marital Status */}
						{formData.brothers.map((bro, index) => (
							<Box key={index} sx={{ mb: 2 }}>
								<TextField
									fullWidth
									label={`Brother ${index + 1} Age`}
									size="small"
									type="number"
									value={bro.age || ''}
									onChange={(e) => updateBrother(index, 'age', Number(e.target.value))}
									sx={{ mb: 3 }}
								/>

								{Number(bro.age) >= 21 && (
									<FormControl fullWidth size="small">
										<InputLabel>Marital Status</InputLabel>
										<Select
											value={bro.maritalStatus || ''}
											label="Marital Status"
											onChange={(e) =>
												updateBrother(index, 'maritalStatus', e.target.value)
											}
										>
											<MenuItem value="Married">Married</MenuItem>
											<MenuItem value="Unmarried">Un Married</MenuItem>
										</Select>
									</FormControl>
								)}
							</Box>
						))}

						{/* Sisters Dropdown */}


						{/* Sister Age and Marital Status */}
						{formData.sisters.map((sis, index) => (
							<Box key={index} sx={{ mb: 2 }}>
								<TextField
									fullWidth
									label={`Sister ${index + 1} Age`}
									size="small"
									type="number"
									value={sis.age || ''}
									onChange={(e) => updateSister(index, 'age', Number(e.target.value))}
									sx={{ mb: 3 }}
								/>
								{Number(sis.age) >= 18 && (
									<FormControl fullWidth size="small">
										<InputLabel>Marital Status</InputLabel>
										<Select
											value={sis.maritalStatus || ''}
											label="Marital Status"
											onChange={(e) =>
												updateSister(index, 'maritalStatus', e.target.value)
											}
										>
											<MenuItem value="Married">Married</MenuItem>
											<MenuItem value="Unmarried">Un Married</MenuItem>
										</Select>
									</FormControl>
								)}
							</Box>
						))}

						<Autocomplete
							options={countriesList}
							value={profileData?.familyDetails?.country || country}
							getOptionLabel={(option) => option.countryName || ""}
							onChange={handleCountryChange}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Country"
									variant="outlined"
									size="small"
								/>
							)}
						/>
						<Autocomplete
							options={statesList}
							value={profileData?.familyDetails?.state || state}
							getOptionLabel={(option) => option.stateName || ""}
							onChange={handleStateChange}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="State"
									variant="outlined"
									size="small"
								/>
							)}
						/>

						<Autocomplete
							options={districtsList}
							value={profileData?.familyDetails?.district || district}
							getOptionLabel={(option) => option.districtName || ""}
							onChange={handleDistrictChange}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="District"
									variant="outlined"
									size="small"
								/>
							)}
						/>
						<Autocomplete
							options={citiesList}
							value={profileData?.familyDetails?.city || city}
							getOptionLabel={(option) => option.cityName || ""}
							onChange={handleCityChange}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="City"
									variant="outlined"
									size="small"
								/>
							)}
						/>

					</FormGrid>

					<Typography variant="h6" style={styles.formTitle}>
						Father Details
					</Typography>

					<FormGrid>
						<StyledTextField
							fullWidth
							label="Father Name (1)"
							variant="outlined"
							size="small"
							value={formData.fatherName}
							onChange={(e) =>
								setFormData({ ...formData, fatherName: e.target.value })
							}
						/>
						{/* <Autocomplete
							options={familyStatusList}
							getOptionLabel={(option) => option.name}
							value={
								familyStatusList.find(
									(option) => option.id === profileData?.familyDetails?.fatherStatus
								) || selectedFamilyStatus
							}
							onChange={(event, newValue) => {
								setSelectedFamilyStatus(newValue);
							}}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Family Status"
									variant="outlined"
									size="small"
								/>
							)}
						/>
						<Autocomplete
							options={religions}
							getOptionLabel={(option) => option.religionName}
							value={
								religions.find(
									(option) => option.id === profileData?.familyDetails?.fatherReligion?.id
								) || fatherReligionValue
							}
							onChange={(event, newValue) => setFatherReligionValue(newValue)}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Father Religion"
									variant="outlined"
									size="small"
								/>
							)}
						/>

						<Autocomplete
							options={castes}
							getOptionLabel={(option) => option.castName}
							value={
								castes.find(
									(option) => option.id === profileData?.familyDetails?.fatherCast?.id
								) || fatherCaste
							}
							onChange={(event, newValue) => setFatherCaste(newValue)}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Father Caste"
									variant="outlined"
									size="small"
								/>
							)}
						/>
						{/* <Autocomplete
							options={gotras}
							getOptionLabel={(option) => option.label}
							value={gotra}
							onChange={(event, newValue) => setGotra(newValue)}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Gotra/Kul"
									variant="outlined"
									size="small"
								/>
							)}
						/> */}
						{/* <StyledFormControl fullWidth size="small">
							<InputLabel>Gotra/Kul</InputLabel>
							<Select label="Gotra/Kul">
								<MenuItem value="Bharadwaja">Bharadwaja</MenuItem>
								<MenuItem value="Kashyapa">Kashyapa</MenuItem>
								<MenuItem value="gotra3">Vasistha</MenuItem>
								<MenuItem value="other">Vishvamitra</MenuItem>
							</Select>
						</StyledFormControl> */}

						<StyledFormControl fullWidth size="small">
							<InputLabel>Father Status</InputLabel>
							<Select
								label="Father Status"
								value={formData.fatherStatus}
								onChange={(e) =>
									setFormData({ ...formData, fatherStatus: e.target.value })
								}
							>
								<MenuItem value={FATHER_STATUS.employed}>Employed</MenuItem>
								<MenuItem value={FATHER_STATUS.business}>Business</MenuItem>
								<MenuItem value={FATHER_STATUS.retired}>Retired</MenuItem>
								<MenuItem value={FATHER_STATUS.not_alive}>Not Alive</MenuItem>
							</Select>
						</StyledFormControl>
						<div style={{ marginTop: '-1px' }}>
							<PhoneInput
								country={'in'}
								value={formData.fatherMobileNumber}
								onChange={(phone) =>
									setFormData({ ...formData, fatherMobileNumber: phone })
								}
								inputStyle={{
									fontSize: "14px",
									paddingLeft: "48px",
									borderColor: formData.fatherMobileNumber ? "#d32f2f" : "#e0e0e0",
								}}
								buttonStyle={{
									backgroundColor: "transparent",
									borderColor: formData.fatherMobileNumber ? "#d32f2f" : "#e0e0e0",
									borderRadius: "4px 0 0 4px",
								}}
								enableSearch={true}
								disableSearchIcon={false}
							/>
						</div>
						<StyledFormControl fullWidth size="small">
							<InputLabel>Is Father Converted Caste</InputLabel>
							<Select
								value={formData.isFatherConvertedCaste}
								onChange={(e) =>
									setFormData({
										...formData,
										isFatherConvertedCaste: e.target.value,
									})
								}
								label="Is Father Converted Caste"
							>
								<MenuItem value={1}>Yes</MenuItem>
								<MenuItem value={0}>No</MenuItem>
							</Select>
						</StyledFormControl>

						<StyledFormControl fullWidth size="small">
							<InputLabel>Father Health Condition</InputLabel>
							<Select
								value={formData.fatherHealthCondition?.id || ''}
								onChange={(e) =>
									setFormData({
										...formData,
										fatherHealthCondition: healthConditionsList.find(
											(item) => item.id === e.target.value
										),
									})
								}
								label="Father Health Condition"
							>
								{healthConditionsList && healthConditionsList.length > 0 ? (
									healthConditionsList.map((condition) => (
										<MenuItem key={condition.id} value={condition.id}>
											{condition.name}
										</MenuItem>
									))
								) : (
									<MenuItem value="">Loading options...</MenuItem>
								)}
							</Select>
						</StyledFormControl>
						<StyledFormControl fullWidth size="small">

							{/* <Autocomplete
								options={employedIn}
								getOptionLabel={(option) => option.name}
								value={profileData?.familyDetails?.fatherWorkingSector || formData.fatherWorkingSector}
								onChange={(event, newValue) => setFormData({
									...formData,
									fatherWorkingSector: newValue,
								})}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Father Working Sector"
										variant="outlined"
										size="small"
									/>
								)}
							/>
						</StyledFormControl> */}
							<Autocomplete
								options={employedIn}
								getOptionLabel={(option) => option.name}
								value={employedIn.find(
									(option) =>
										option.name ===
										(formData.fatherWorkingSector?.name || formData.fatherWorkingSector)
								) || null}
								onChange={(event, newValue) =>
									setFormData({
										...formData,
										fatherWorkingSector: newValue,
									})
								}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Father Working Sector"
										variant="outlined"
										size="small"
									/>
								)}
							/>
						</StyledFormControl>

						<Autocomplete
							options={professionsList}
							getOptionLabel={(option) => option.designationName}
							value={fatherProfession}
							onChange={(event, newValue) => setFatherProfession(newValue)}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Father Profession"
									variant="outlined"
									size="small"
								/>
							)}
						/>
						<StyledTextField
							fullWidth
							label="Father Address"
							value={formData.fatherAddress}
							onChange={(e) =>
								setFormData({ ...formData, fatherAddress: e.target.value })
							}
							size="small"
							multiline
							rows={2}
						/>

						{formData.fatherStatus == 1 || formData.fatherStatus == 2 && <StyledTextField
							fullWidth
							label="Father Annual Income"
							value={formData.fatherAnualIncome}
							onChange={(e) =>
								setFormData({ ...formData, fatherAnualIncome: e.target.value })
							}
							size="small"
							type="number"
						/>}

						<StyledTextField
							fullWidth
							label="Father Property Details"
							value={formData.fatherPropertyDetails}
							onChange={(e) =>
								setFormData({
									...formData,
									fatherPropertyDetails: e.target.value,
								})
							}
							size="small"
							multiline
							rows={2}
						/>

						{formData.fatherStatus == 3 && <StyledTextField
							fullWidth
							label="Pension"
							value={formData.pension}
							onChange={(e) =>
								setFormData({ ...formData, pension: e.target.value })
							}
							size="small"
						/>}
					</FormGrid>

					<Typography variant="h6" style={styles.formTitle}>
						Mother Details
					</Typography>

					<FormGrid>
						<StyledTextField
							fullWidth
							label="Mother Name"
							variant="outlined"
							size="small"
							value={formData.motherName}
							onChange={(e) =>
								setFormData({ ...formData, motherName: e.target.value })
							}
						/>

						<Autocomplete
							options={religions}
							getOptionLabel={(option) => option.religionName}
							value={profileData?.familyDetails?.motherReligion || motherReligionValue}
							onChange={(event, newValue) => setMotherReligionValue(newValue)}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Mother Religion"
									variant="outlined"
									size="small"
								/>
							)}
						/>
						<Autocomplete
							options={castes}
							getOptionLabel={(option) => option.castName}
							value={motherCaste}
							onChange={(event, newValue) => setMotherCaste(newValue)}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Caste"
									variant="outlined"
									size="small"
								/>
							)}
						/>

						{/* <Autocomplete
							options={gotras}
							getOptionLabel={(option) => option.label}
							value={motherGotra}
							onChange={(event, newValue) => setMotherGotra(newValue)}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Gotra/Kul"
									variant="outlined"
									size="small"
								/>
							)}
						/> */}

						<StyledFormControl fullWidth size="small">
							<InputLabel>Mother Status</InputLabel>
							<Select
								label="Mother Status"
								value={formData.motherStatus}
								onChange={(e) =>
									setFormData({ ...formData, motherStatus: e.target.value })
								}
							>
								<MenuItem value={MOTHER_STATUS.housewife}>Housewife</MenuItem>
								<MenuItem value={MOTHER_STATUS.employed}>Employed</MenuItem>
								<MenuItem value={MOTHER_STATUS.business}>Business</MenuItem>
								<MenuItem value={MOTHER_STATUS.retired}>Retired</MenuItem>
								<MenuItem value={MOTHER_STATUS.not_alive}>Not Alive</MenuItem>
							</Select>
						</StyledFormControl>
						<div style={{ marginTop: '-1px' }}>
							<PhoneInput
								country={'in'}
								value={formData.motherMobileNumber}
								onChange={(phone) =>
									setFormData({ ...formData, motherMobileNumber: phone })
								}
								inputStyle={{
									fontSize: "14px",
									paddingLeft: "48px",
									borderColor: formData.motherMobileNumber ? "#d32f2f" : "#e0e0e0",
								}}
								buttonStyle={{
									backgroundColor: "transparent",
									borderColor: formData.motherMobileNumber ? "#d32f2f" : "#e0e0e0",
									borderRadius: "4px 0 0 4px",
								}}
								enableSearch={true}
								disableSearchIcon={false}
							/>
						</div>
						<StyledTextField
							fullWidth
							label="Mother Maiden Name"
							variant="outlined"
							size="small"
							value={profileData?.familyDetails?.motherMaidenName || formData.motherMaidenName}
							onChange={(e) =>
								setFormData({ ...formData, motherMaidenName: e.target.value })
							}
						/>

						<StyledFormControl fullWidth size="small">
							<InputLabel>Is Mother Converted Caste</InputLabel>
							<Select
								value={formData.isMotherConvertedCaste}
								onChange={(e) =>
									setFormData({
										...formData,
										isMotherConvertedCaste: e.target.value,
									})
								}
								label="Is Mother Converted Caste"
							>
								<MenuItem value={1}>Yes</MenuItem>
								<MenuItem value={0}>No</MenuItem>
							</Select>
						</StyledFormControl>

						<StyledFormControl fullWidth size="small">
							<InputLabel>Mother Health Condition</InputLabel>

							<Select
								value={formData.motherHealthCondition?.id || ''}
								onChange={(e) =>
									setFormData({
										...formData,
										motherHealthCondition: healthConditionsList.find(
											(item) => item.id === e.target.value
										),
									})
								}
								label="Mother Health Condition"
							>
								{healthConditionsList && healthConditionsList.length > 0 ? (
									healthConditionsList.map((condition) => (
										<MenuItem key={condition.id} value={condition.id}>
											{condition.name}
										</MenuItem>
									))
								) : (
									<MenuItem value="">Loading options...</MenuItem>
								)}
							</Select>
						</StyledFormControl>

						<Autocomplete
							options={professionsList}
							getOptionLabel={(option) => option.designationName}
							value={motherProfession}
							onChange={(event, newValue) => setMotherProfession(newValue)}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Mother Profession"
									variant="outlined"
									size="small"
								/>
							)}
						/>

						{(formData.motherStatus == 2 || formData.motherStatus == 3) && <StyledTextField
							fullWidth
							label="Mother Annual Income"
							value={formData.motherAnualIncome}
							onChange={(e) =>
								setFormData({ ...formData, motherAnualIncome: e.target.value })
							}
							size="small"
							type="number"
						/>}
						{formData.motherStatus == 4 && <StyledTextField
							fullWidth
							label="Pension"
							value={formData.mothenPension}
							onChange={(e) =>
								setFormData({ ...formData, mothenPension: e.target.value })
							}
							size="small"
							type="number"
						/>}

						<StyledTextField
							fullWidth
							label="Mother Property Details"
							value={formData.motherPropertyDetails}
							onChange={(e) =>
								setFormData({
									...formData,
									motherPropertyDetails: e.target.value,
								})
							}
							size="small"
							multiline
							rows={2}
						/>
					</FormGrid>

					<Typography variant="h6" style={styles.formTitle}>
						Reference Details
					</Typography>

					<FormGrid>
						<StyledTextField
							fullWidth
							label="Full Name"
							variant="outlined"
							size="small"
							value={formData.referenceName}
							onChange={(e) =>
								setFormData({ ...formData, referenceName: e.target.value })
							}
						/>
						<div style={{ marginTop: '-1px' }}>
							<PhoneInput
								country={'in'}
								value={formData.referenceMobileNmuber}
								onChange={(phone) =>
									setFormData({ ...formData, referenceMobileNmuber: phone })
								}
								inputStyle={{
									fontSize: "14px",
									paddingLeft: "48px",
									borderColor: formData.referenceMobileNmuber ? "#d32f2f" : "#e0e0e0",
								}}
								buttonStyle={{
									backgroundColor: "transparent",
									borderColor: formData.referenceMobileNmuber ? "#d32f2f" : "#e0e0e0",
									borderRadius: "4px 0 0 4px",
								}}
								enableSearch={true}
								disableSearchIcon={false}
							/>
						</div>

						<Autocomplete
							options={relationList}
							getOptionLabel={(option) => option.name}
							value={profileData?.familyDetails?.relation || relation}
							onChange={(event, newValue) => setRelation(newValue)}
							renderInput={(params) => (
								<StyledTextField
									{...params}
									label="Relation"
									variant="outlined"
									size="small"
								/>
							)}
						/>



						<StyledTextField
							fullWidth
							label="Address"
							variant="outlined"
							size="small"
							value={formData.referenceAddress}
							onChange={(e) =>
								setFormData({ ...formData, referenceAddress: e.target.value })
							}
						/>
					</FormGrid>

					<StyledButton
						variant="contained"
						onClick={handleContinue}
						sx={{
							width: { xs: "100%", sm: "160px" },
							marginTop: { xs: 3, md: 4 },
							padding: "15px 0px",
						}}
					>
						Save & Continue
					</StyledButton>
				</div>
			</FormContainer>
		</Container>
	);
};

export default FamilyDetailsForm;
